import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import {
  getUserAddresses,
  getUserInfo, changeAddress,
  putUserInfo, changeUserPassword,
  userLogout, withDraw, putUserAgreement
} from '../../apis/user';
import Dialog from '@mui/material/Dialog';
import { AddressPopUp } from '../../components/AddressPopUp';
import { Button } from '../../components/Button';
import { Checkbox } from '../../components/Checkbox';
import { DirectoryBar } from '../../components/DirectoryBar';
import { H3 } from '../../components/H3';
import { H4 } from '../../components/H4';
import { VerificationPopup } from '../../components/VerificationPopup';
import { PhoneNumberCustom } from '../../components/PhoneNumberCustom';
import { Icon } from '../../components/Icon';
import { PhoneNumber } from '../../components/PhoneNumber';
import { PopUp } from "../../components/PopUp";
import { PostPopUp } from '../../components/PostPopUp';
import { Section } from '../../components/Section';
import { Select } from '../../components/Select';
import { TextField } from '../../components/TextField';
import { AIRBRIDGE_EVENT } from '../../constants/airbridge';
import { BRAZE_EVENT } from "../../constants/braze";
import { useUserDispatch, useUserState } from '../../context/UserContext';
import { Bridge } from '../../plugins/bridge';
import { nToast } from '../../plugins/reactToast';
import {AgreementType, ChangePasswordDto, UserAddress, UserInfo, UserInfoModifyDto} from '../../types/types';
import { addressSort } from "../../utils/addressSort";
import moment from "moment/moment";
import {Label} from "../../components/Label";
import {isMobile} from "react-device-detect";

export const MyPageEdit = () => {
  const history = useHistory();
  const [me, setMe] = useState<UserInfo>();
  const [addresses, setAddresses] = useState<UserAddress[]>([]);
  const [addressPopUp, setAddressPopUp] = useState(false);
  const form = useForm<UserInfoModifyDto>();
  const [addressType, setAddressType] = useState<number>(0);
  const [postModal, setPostModal] = useState<boolean>(false);
  const { isLoggedIn } = useUserState();
  const dispatch = useUserDispatch();
  const [withDrawPopup, setWithDrawPopup] = useState(false);
  const userBirthParts = me?.userBirth ? me?.userBirth.split('-') : [];
  const userYear = userBirthParts[0];
  const userMonth = parseInt(userBirthParts[1]).toString();
  const userDay = parseInt(userBirthParts[2]).toString();
  const [verifiedPopup, setVerifiedPopup] = useState(false);
  const [pwFind, setPwFind] = useState(false);
  const [_isMobile, setMobile] = useState(false);
  const methods = useForm<UserInfoModifyDto>({ mode: 'onChange' });
  const {
    formState,
    register,
    getValues,
    setValue,
    handleSubmit,
    watch,
    formState: { errors, isValid },
  } = methods;

  useEffect(() => {
    setMobile(isMobile);
  }, [isMobile]);

  const [birth, setBirth] = useState<{
    year: string;
    month: string;
    day: string;
  }>({ year: '', month: '', day: '' });

  useEffect(() => {
    if (birth && (birth.year || birth.month || birth.day)) {
      form.setValue(
          'birth',
          moment(
              new Date(
                  parseInt(birth.year || userYear),  // 현재 년도 값 사용
                  parseInt(birth.month || userMonth) - 1,
                  parseInt(birth.day || userDay)
              )
          ).format('YYYY-MM-DD'),
          { shouldValidate: true }
      );
    }
  }, [birth]);

  const changePassword = ({password, newPassword, confirmPassword}: UserInfoModifyDto) => {
    if (newPassword !== confirmPassword) return;
    changeUserPassword({password: password, newPassword: newPassword, confirmPassword: confirmPassword})
        .then((response) => {
          if (response.data.code === 'SUCCESS') {
            //setSuccessPopup(true)
            setValue('password', '');
            setValue('newPassword', '');
            setValue('confirmPassword', '');
            nToast('비밀번호가 변경 되었습니다.');
            setPwFind(false);
          }
        })
        .catch((err) => {
          nToast(err.response.data.message);
        });
  };


  useEffect(() => {
    // if (isLoggedIn) {
      getInfos();
    // } else {
    //   history.replace('/login');
    // }
  }, []);

  useEffect(() => {
    if (addressType === 0) setNewAddress();
  }, [addressType]);

  const getInfos = () => {
    getUserInfo().then(r => {
      if (r && r.data) {
        const data = r.data.payload;
        form.setValue(`name`, data.userName);
        form.setValue(`gender`, data.userGender!);
        form.setValue(`phone`, data.userPhone.replaceAll('-', ''));
        form.setValue(`agreements`, data.agreements as AgreementType[]);
        setMe(r.data.payload);
      }
    }).catch(e => console.log(e));
    getUserAddresses().then(r => {
      const data = r.data.payload;
      const adds = addressSort(data);
      setAddresses(adds);
      setDefaultAddress(data);
    }).catch(e => console.log(e));
  };

  const setNewAddress = () => {
    form.setValue(`address.address`, '');
    form.setValue(`address.addressName`, '');
    form.setValue(`address.detailAddress`, '');
    form.setValue(`address.gugun`, '');
    form.setValue(`address.isDefault`, true);
    form.setValue(`address.phone`, '');
    form.setValue(`address.postcode`, '');
    form.setValue(`address.receiverName`, '');
    form.setValue(`address.requestMessage`, '');
    form.setValue(`address.sido`, '');
    form.setValue(`address.userAddressId`, undefined);
    form.setValue(`address.isDefault`, false);
  };

  const setDefaultAddress = (list: UserAddress[]) => {
    const defaultAddress = list.find(item => item.isDefault);
    if (defaultAddress || list.length > 0) {
      setAddressType(1);
      form.setValue(`address.address`, defaultAddress ? defaultAddress.address : list[0].address);
      form.setValue(`address.addressName`, defaultAddress ? defaultAddress.addressName : list[0].addressName);
      form.setValue(`address.detailAddress`, defaultAddress ? defaultAddress.detailAddress : list[0].detailAddress);
      form.setValue(`address.gugun`, defaultAddress ? defaultAddress.gugun : list[0].gugun);
      form.setValue(`address.isDefault`, defaultAddress ? defaultAddress.isDefault : list[0].isDefault);
      form.setValue(`address.phone`, defaultAddress ? defaultAddress.phone : list[0].phone);
      form.setValue(`address.postcode`, defaultAddress ? defaultAddress.postcode : list[0].postcode);
      form.setValue(`address.receiverName`, defaultAddress ? defaultAddress.receiverName : list[0].receiverName);
      form.setValue(`address.requestMessage`, defaultAddress ? defaultAddress.requestMessage : list[0].requestMessage);
      form.setValue(`address.sido`, defaultAddress ? defaultAddress.sido : list[0].sido);
      form.setValue(`address.userAddressId`, defaultAddress ? defaultAddress.addressId : list[0].addressId);
    } else {
      setNewAddress();
    }
  };

  const sendingLog = async () => {
    const appboy = require('@braze/web-sdk');
    await Bridge.sendAirbridge(AIRBRIDGE_EVENT.signOut);
    await Bridge.sendBraze(BRAZE_EVENT.SIGN_OUT);
    Bridge.sendAirbridge("clearUser");
    // airbridge.clearUser();
  };

  const logout = () => {
    userLogout().then(async r => {
      dispatch({ type: 'LOGOUT' });
      nToast(`로그아웃 되었습니다`);
      history.push('/');
      window.location.reload();
    }).catch(e => console.log(e));
  };

  const onSubmit = () => {
    const data = form.watch()
    putUserInfo(data).then(res => {
          if (res.data.code === 'SUCCESS') {
            // Bridge.sendBraze("modifyingGrant", {
            //   EmailNotificationSubscriptionType : data.agreements.indexOf('MAILING'),
            //   PushNotificationSubscriptionType : data.agreements.indexOf('SMS')
            // })
              nToast(`정보가 수정되었습니다`);
              getInfos();
          }
        })
        .catch(err => {
          // TODO: error handling
          if (err.response.data.message) {
            nToast(err.response.data.message);
          } else {
            nToast('에러가 발생했습니다. 고객센터에 문의해주세요.');
          }
          console.log(err);
        });
  };

  const onAddress = () => {
    if (
        form.watch().address.address &&
        form.watch().address.addressName &&
        form.watch().address.gugun &&
        form.watch().address.phone &&
        form.watch().address.postcode &&
        form.watch().address.sido
    ) {
      const data = form.watch().address
      changeAddress(data).then(r => {
        var tmp: any[] = [];
        form.watch().agreements?.forEach((aggrement) => {
          tmp.push(String(aggrement));
        });
        console.log('요청 데이터:', form.watch());
        nToast(`정보가 수정되었습니다`);
        getInfos();
      }).catch(e => console.log(e));
    } else {
      nToast('필수 정보를 모두 입력해 주세요');
    }
  };

  const handleCheck = (item: AgreementType) => {
    let list = [...form.watch().agreements ?? []];
    const idx = form.watch().agreements?.indexOf(item);
    if (idx !== undefined && idx !== -1) {
      list.splice(idx, 1);
    } else {
      list.push(item);
    }
    putUserAgreement(list)
        .then(() => {
          getInfos();
        })
        .catch((err) => {
          if (err.response?.data?.message) {
            nToast(err.response.data.message);
          } else {
            nToast('에러가 발생했습니다. 고객센터에 문의해주세요.');
          }
          console.log(err);
        });
  };

  const goWithDraw = () => {
    withDraw().then(r => {
      alert('회원 탈퇴 처리되었습니다.');
      userLogout().then(async r => {
        history.push('/');
        window.location.reload();
      }).catch(e => console.log(e));
    });
  };
  const days = () => {
    const dt = new Date(parseInt(userYear), parseInt(userMonth), 0);
    return Array.from({ length: dt.getDate() }, (_, i) => i + 1);
  };
  const years = () => {
    const dt = new Date();
    const commonYear = dt.getFullYear();
    let years: number[] = [];
    for (let i = commonYear - 100; i <= commonYear; i++) {
      years.push(i);
    }
    return years.reverse();
  };
  if (!me) return null;
  return (
    <div className="pb-20">
      <VerificationPopup
          title="휴대폰 본인인증 진행"
          description={me.isVerified ? '휴대폰 본인인증 통해 내 정보를 수정할 수 있습니다.' : '휴대폰 본인인증 후에 웍스아웃의 더 많은 혜택을 누려보세요.'}
          description2={!me.isVerified &&
              '<div style="font-weight: 600">\n' +
              '                  - 한정판 상품 응모 가능<br/>\n' +
              '                  - 한정판 상품 선착 발매 시 구매 가능<br/>\n' +
              '                  - 회원 전용 상품 발매 시 구매 가능\n' +
              '                </div>'
          }
          buttonText="휴대폰 본인인증"
          open={verifiedPopup}
          onClose={() => setVerifiedPopup(false)}
      />
      <Dialog
          open={pwFind}
          onClose={() => setPwFind(false)}
          fullWidth={_isMobile ? (true):(false)}
          className={`max-w-sm m-auto CustomMui`}
      >
        <div className={`p-4 rounded-none flex flex-col gap-y-4`}>
          <div className={`flex justify-between items-center`}>
            <p className={`font-semibold text-13`}>비밀번호 변경</p>
            <Icon.X onClick={() => setPwFind(false)} className={`wh-5 cursor-pointer`} />
          </div>
          <div className={`flex flex-col gap-y-4`}>
            <TextField
                type="password"
                label="현재 비밀번호"
                placeholder="현재 비밀번호를 입력해주세요."
                defaultValue={''}
                {...register('password', {
                  required: false,
                })}
            />
            <TextField
                type="password"
                label="신규 비밀번호"
                placeholder="신규 비밀번호를 입력해주세요."
                valid={!errors.newPassword?.message && !!watch().newPassword}
                validText={'사용가능한 비밀번호 입니다.'}
                helper={errors.newPassword?.message}
                defaultValue={''}
                {...register('newPassword', {
                  required: false,
                  validate: value => {
                    if (value?.length < 8 && pwFind) {
                      return '최소 8자 이상 가능합니다';
                    }
                    if (value?.length > 15  && pwFind) {
                      return '최대 15자 까지만 가능합니다';
                    }
                  },
                })}
            />
            <TextField
                type="password"
                label="신규 비밀번호 확인"
                placeholder="신규 비밀번호를 다시 입력해주세요."
                valid={formState.isValid}
                validText={'비밀번호가 일치합니다.'}
                defaultValue={''}
                helper={errors.confirmPassword?.message}
                {...register('confirmPassword', {
                  required: false,
                  validate: value =>
                      value === watch().newPassword || '비밀번호가 일치하지 않습니다',
                })}
            />
          </div>
          <Button
              disabled={
                  !watch().password ||
                  !watch().newPassword ||
                  !watch().confirmPassword ||
                  !formState.isValid ||
                  !!errors.newPassword?.message ||
                  !!errors.confirmPassword?.message
              }
              onClick={handleSubmit(changePassword)}
              text={`변경하기`}
              className={`bg-black text-white mt-2`}
          />
        </div>
      </Dialog>
      <PostPopUp
        open={postModal}
        onClose={() => setPostModal(false)}
        onSelected={data => {
          form.setValue('address.postcode', data.zonecode.toString());
          form.setValue('address.sido', data.sido);
          form.setValue('address.gugun', data.sigungu);
          form.setValue('address.address', data.address.replace(data.sido, '').replace(data.sigungu, '').trim());
          setPostModal(false);
        }}
      />

      <DirectoryBar text="내 정보 수정" backArrow className="md:hidden" />
      <Section>
        <H3 className="text-14">내 정보 수정</H3>
        <div className="border-b border-gray-200 my-3" />

        <div className="mb-4 text-14 flex justify-between">
          <p>나의 정보</p>
          <button
              className={`underline`}
              onClick={() => setPwFind(true)}
          >
            비밀번호 변경
          </button>
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
          <TextField
              label="아이디(이메일)"
              disabled
              defaultValue={me.userEmail}
          />
          <TextField
              label="이름"
              placeholder="이름"
              disabled={me.isVerified}
              defaultValue={form.watch().name}
              {...form.register(`name`, { required: true })}
          />
          <Select
              label="성별"
              className={`border pl-4 ${me.isVerified && 'select-arrow-none'}`}
              disabled={me.isVerified}
              defaultValue={form.watch().gender}
              // @ts-ignore
              onChange={e => form.setValue('gender', e.target.value)}>
            <option disabled hidden>
              성별을 선택해주세요.
            </option>
            <option value="MALE">남자</option>
            <option value="FEMALE">여자</option>
            <option value="ETC">선택 안 함</option>
          </Select>
          <div className="grid grid-cols-3 gap-x-4 gap-y-1">
            <Label text="생년월일" className={`col-span-3`} />
            <Select
                className={`border text-14 pl-4 ${errors.birth ? 'border-error border-black' : 'text-12'} ${me.isVerified && 'select-arrow-none'}`}
                onChange={(e) => setBirth({ ...birth, year: e.target.value })}
                disabled={me.isVerified}
            >
              <option>{userYear}</option>
              {years().map((item, index) => (
                  <option key={`year-${index}`} value={item.toString()}>
                    {item}
                  </option>
              ))}
            </Select>
            <Select
                className={`border text-14 pl-4 ${errors.birth ? 'border-error border-black' : 'text-12'} ${me.isVerified && 'select-arrow-none border-gray-500'}`}
                onChange={e => setBirth({ ...birth, month: e.target.value })}
                disabled={me.isVerified}
            >
              <option>{userMonth}</option>
              {Array.from({ length: 12 }, (_, i) => i + 1).map((item, index) => (
                  <option key={`month-${index}`} value={item.toString()}>
                    {item}
                  </option>
              ))}
            </Select>
            <Select
                className={`border text-14 pl-4 ${errors.birth ? 'border-error border-black' : 'text-12'} ${me.isVerified && 'select-arrow-none border-gray-500'}`}
                onChange={e => setBirth({ ...birth, day: e.target.value })}
                disabled={me.isVerified}
            >
              <option>{userDay}</option>
              {days().map((item, index) => (
                  <option key={`day-${index}`} value={item.toString()}>
                    {item}
                  </option>
              ))}
            </Select>
          </div>
          <div className={`md:col-span-2`}>
            <PhoneNumberCustom
                label="핸드폰 번호"
                value={form.watch().phone}
                disabled={me.isVerified}
                needVerify
                onVerified={phone =>
                    form.setValue(`phone`, phone.replaceAll('-', ''))
                }
            />
          </div>
          {!me.isVerified &&
              <Button
                  text="수정하기"
                  className="filled-gray-900"
                  style={{width:'156px'}}
                  onClick={handleSubmit(onSubmit)}
              />
          }
        </div>
      </Section>
      <div className={`flex flex-col col-span-3 gap-y-2 my-4 border-t pt-4`}>
        <Button
            className={`border border-gray-900`}
            style={{width:'49%'}}
            text={`${me.isVerified ? '재인증하기' : '본인인증 하기'}`}
            onClick={( ) => setVerifiedPopup(true)}
        />
        <p className={`flex gap-x-1 text-12 ${me.isVerified ? 'text-gray-900' : 'text-red-500'}`}>
          {me.isVerified
              ? '본인인증 완료'
              : <><span className={`border rounded-full border-red-500 wh-4 block flex items-center justify-center`}>!</span>본인인증 필요<br/>본인인증이 안된 계정은 응모 및 일부 상품 구매 시 제한 될 수 있습니다.</>
          }
        </p>
      </div>
      <Section>
        <div className="border-b border-gray-200 my-8" />
        {/*<H4 className="font-medium mb-4">배송 정보</H4>*/}
        <Section className="space-y-4">
          <div className="pb-4 text-14 flex justify-between">
            <p>배송 정보</p>
            <button
                className="text-13 underline"
                onClick={() => setAddressPopUp(true)}>
              배송지 목록
            </button>
          </div>
          <div className="flex">
            <div className="space-x-4">
              <Button
                text="기존 배송지"
                className={
                  addressType === 1
                    ? 'filled-gray-900 px-6 font-normal '
                    : 'border border-gray-400 px-5 font-normal'
                }
                onClick={() => {
                  setAddressType(1);
                  setDefaultAddress(addresses);
                }}
              />
              {addresses.length < 5 && (
                <Button
                  text="신규 입력"
                  className={
                    addressType === 0
                      ? 'filled-gray-900 px-6 font-normal '
                      : 'border border-gray-400 px-5 font-normal'
                  }
                  onClick={() => setAddressType(0)}
                />
              )}
            </div>
            <AddressPopUp
              open={addressPopUp}
              onClose={() => setAddressPopUp(false)}
              addresses={addresses}
              onSelected={data => {
                setAddressType(1);
                form.setValue('address.userAddressId', data.addressId);
                form.setValue('address.addressName', data.addressName);
                form.setValue('address.receiverName', data.receiverName!);
                form.setValue('address.phone', data.phone);
                form.setValue('address.postcode', data.postcode);
                form.setValue('address.sido', data.sido);
                form.setValue('address.gugun', data.gugun);
                form.setValue('address.address', data.address);
                form.setValue('address.detailAddress', data.detailAddress);
                form.setValue('address.requestMessage', data.requestMessage);
                form.setValue('address.isDefault', data.isDefault);
                setAddressPopUp(false);
              }}
            />
          </div>

          <div className="md:grid grid-cols-2 md:w-2/3 gap-4 space-y-4 md:space-y-0 ">
            <TextField
              label="배송지명 *"
              placeholder="배송지명을 입력해주세요."
              className=""
              defaultValue={form.watch().address.addressName}
              helper={form.formState.errors.address?.addressName?.message}
              {...form.register('address.addressName', {
                required: '배송지명을 입력해 주세요',
              })}
            />
            <TextField
              label="수령인 이름 *"
              placeholder="수령인 이름을 적어주세요."
              className=""
              defaultValue={form.watch().address.receiverName}
              helper={form.formState.errors.address?.receiverName?.message}
              {...form.register('address.receiverName', {
                required: '수령인 이름을 적어주세요',
              })}
            />
            <PhoneNumber
              label="수취인 전화번호 *"
              value={form.watch().address.phone}
              onChange={e => form.setValue(`address.phone`, e.target.value)}
            />
            <div />

            <div className="col-span-2 space-y-2">
              <div className="flex items-end space-x-4">
                <div className="flex-1">
                  <TextField
                    label="기본 주소 *"
                    placeholder="주소"
                    disabled={true}
                    value={`${form.watch().address.postcode} ${form.watch().address.sido
                      }  ${form.watch().address.gugun} ${form.watch().address.address
                      }`}
                  />
                </div>
                <Button
                  text="검색"
                  className="filled-gray-200 text-black font-light text-sm md:px-10"
                  onClick={() => setPostModal(true)}
                />
              </div>
              <TextField
                placeholder="상세 주소 입력"
                value={form.watch().address.detailAddress}
                helper={form.formState.errors.address?.detailAddress?.message}
                {...form.register('address.detailAddress', {
                  required: '상세 주소를 입력해주세요',
                })}
              />
            </div>
            <div className="col-span-2">
              <TextField
                label="배송시 요청사항"
                placeholder="배송시 요청사항을 입력해주세요."
                value={form.watch().address.requestMessage}
                {...form.register('address.requestMessage')}
              />
            </div>
            <Checkbox
                label="기본 배송지로 등록"
                checked={form.watch().address.isDefault}
                onChange={() =>
                    form.setValue(
                        `address.isDefault`,
                        !form.watch().address.isDefault
                    )
                }
            />
          </div>
        </Section>
        <Button
            text="수정하기"
            className="filled-gray-900 md:px-20 mt-6"
            onClick={onAddress}
        />
        <div className={'label-col border-t border-b py-4 my-4 mt-6'}>
          <label className={'label '}>마케팅 정보 수신 동의</label>
          <div className="grid grid-cols-2 gap-2 max-w-md" style={{ marginTop: 15 }}>
            <Checkbox
                label="E-mail"
                checked={(form.watch().agreements?.indexOf(AgreementType.MAILING) ?? -1) > -1}
                onChange={_ => handleCheck(AgreementType.MAILING)}
            />
            <Checkbox
                label="PUSH, SMS 등"
                checked={(form.watch().agreements?.indexOf(AgreementType.SMS) ?? -1) > -1}
                onChange={_ => handleCheck(AgreementType.SMS)}
            />
          </div>
        </div>
        <Button
            onClick={() => setWithDrawPopup(true)}
            text="회원탈퇴"
            className="outlined-gray-900 md:px-20"
        />
      </Section>
      <PopUp
        title="회원 탈퇴"
        description={`회원 탈퇴 시, 보유하고 계신 적립금과 쿠폰은 모두 소멸됩니다.\n탈퇴 후 동일한 정보로 재가입 시, 6개월 내 중복 쿠폰 재발급이 불가능합니다.\n탈퇴 하시겠습니까?`}
        buttonText="탈퇴하기"
        open={withDrawPopup}
        onClose={() => setWithDrawPopup(false)}
        onClick={() => goWithDraw()}
        onClickMobile={() => goWithDraw()}
      />
    </div>
  );
};
